module.exports = __webpack_public_path__ + "imgs/image-coming-soon.jpg";